import clsx from 'clsx';
import styles from './styles.module.scss';

type Props = {
    loading?: boolean;
};
export const ContentLoading = ({ loading = false }: Props) => {
    if (!loading) {
        return null;
    }

    return (
        <div className={clsx(styles['content-loading'], { [styles['content-loading--show']]: loading })}>
            <div className={styles['content-loading__logo']}>
                <img src="/assets/svg/kiosk_loading.svg" alt="Kiosk Loading" />
            </div>
        </div>
    );
};
